function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const api = buildService('/claim_project_reports/{id}/project_clones', {
  only: ['create']
});
const cloneStatusApi = buildService('/claim_project_reports/{id}/clone_status', {
  only: ['all', 'base']
});
const projectClonesService = {
  useFetchProjectCloneStatusImportStatusWithInterval: (projectId, setLoading, fetchReports) => {
    const {
      interval,
      setInterval,
      stateVar: importStatus,
      setStateVar: setImportStatus
    } = serviceMethods.useFetchWithInterval({
      api: cloneStatusApi,
      callback: useCallback(async () => {
        const newStatus = await cloneStatusApi.all(projectId);
        if (['done'].includes(newStatus === null || newStatus === void 0 ? void 0 : newStatus.status)) {
          fetchReports();
        }
        return newStatus;
      }, [projectId, fetchReports]),
      setLoading
    });
    return {
      importStatus,
      setImportStatus,
      interval,
      setInterval
    };
  },
  useCreate: (projectId, setLoading, setProjectCloneStatus) => {
    const createProjectCloneStatus = serviceMethods.useCreate({
      callback: useCallback(async () => {
        const newStatus = await api.create(projectId);
        if (setProjectCloneStatus) {
          setProjectCloneStatus(_objectSpread({}, newStatus));
        }
        return newStatus;
      }, [projectId, setProjectCloneStatus]),
      setLoading
    });
    return [createProjectCloneStatus];
  }
};
projectClonesService.useCrud = (projectId, setLoading, fetchReports) => {
  const {
    importStatus,
    setImportStatus,
    interval,
    setInterval
  } = projectClonesService.useFetchProjectCloneStatusImportStatusWithInterval(projectId, setLoading, fetchReports);
  const [createProjectCloneStatus] = projectClonesService.useCreate(projectId, setLoading, setImportStatus);
  return {
    importStatus,
    createProjectCloneStatus,
    interval
  };
};
export default projectClonesService;